import React from "react";
import About from "../components/About";
import Contact from "../components/Contact";
import Skills from "../components/Skills";
import PaintingSlider from "../components/paintingSlider";
import Profile from "../components/Profile";
import ProjectArch from "../components/ProjectArch";
import Product from "../components/Product";
import Slideshow from "../components/Slideshow";
import Footer from "../components/footer";
import ProductTest from "../components/ProductTest";
import Develop from "../components/Develop";

export default function Home() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <About />
      <Slideshow />
      <Profile />
      <Skills />
      <ProjectArch/>
      <Product />
      <Develop/>
      <PaintingSlider />
      <Contact />
      <Footer />
    </main>
  );
}
